import _ from "lodash";

export {
    calculateProductPrice,
    prepareVariantsPriceRange,
    prepareExistingProduct,
}

function calculateProductPrice(variant, printfulProduct) {
    // Calculate the desired profit amount
    let desiredProfit = parseFloat(variant.price) * (printfulProduct.profitPercentage / 100);

    // Calculate the desired selling price
    let msrp = parseFloat(variant.price) + desiredProfit;

    // Round the price to the nearest .99 range
    let roundedMsrpPrice = Math.round(msrp * 100) / 100;
    let msrpPriceIn99Range = Math.floor(roundedMsrpPrice);
    // let msrpPriceIn99Range = Math.floor(roundedMsrpPrice) + 0.99;

    let msrpProfit = msrpPriceIn99Range - parseFloat(variant.price);

    // Apply the discount
    let salePrice = msrp * (1 - printfulProduct.discountPercentage / 100);

    // Round the price to the nearest .99 range
    let roundedSalePrice = Math.round(salePrice * 100) / 100;
    let salePriceIn99Range = Math.floor(roundedSalePrice);
    // let salePriceIn99Range = Math.floor(roundedSalePrice) + 0.99;

    const saleProfit = salePriceIn99Range - parseFloat(variant.price);
    const discountAmount = msrpPriceIn99Range - salePriceIn99Range;

    variant.msrp = msrpPriceIn99Range.toFixed(2);
    variant.msrpProfit = msrpProfit.toFixed(2);
    variant.salePrice = salePriceIn99Range.toFixed(2);
    variant.saleProfit = saleProfit.toFixed(2);
    variant.discountAmount = discountAmount.toFixed(2);
}

const prepareVariantsPriceRange = (variants, printfulProduct, existingProduct) => {
    printfulProduct.costRange = prepareRange(variants, 'price');
    printfulProduct.msrpRange = prepareRange(variants, 'msrp');
    printfulProduct.msrpProfitRange = prepareRange(variants, 'msrpProfit');
    printfulProduct.salePriceRange = prepareRange(variants, 'salePrice');
    printfulProduct.saleProfitRange = prepareRange(variants, 'saleProfit');
    printfulProduct.discountAmountRange = prepareRange(variants, 'discountAmount');

    return prepareExistingProduct(printfulProduct, existingProduct);
}

const prepareExistingProduct = (printfulProduct, existingProduct) => {
    if (!existingProduct) {
        existingProduct = {
            title: printfulProduct.title,
            product_id: printfulProduct.product_id,
            product_type: printfulProduct.product_type,
            category: printfulProduct.category,
            category_id: printfulProduct.category_id,
        }
    }

    existingProduct.profitPercentage = printfulProduct.profitPercentage;
    existingProduct.discountPercentage = printfulProduct.discountPercentage;
    existingProduct.costRange = printfulProduct.costRange;
    existingProduct.msrpRange = printfulProduct.msrpRange;
    existingProduct.msrpProfitRange = printfulProduct.msrpProfitRange;
    existingProduct.salePriceRange = printfulProduct.salePriceRange;
    existingProduct.saleProfitRange = printfulProduct.saleProfitRange;
    existingProduct.discountAmountRange = printfulProduct.discountAmountRange;

    return existingProduct;
}


const prepareRange = (variants, attribute) => {
    const variantValues = _.map(variants, (variant) => {
        return parseFloat(variant[attribute]);
    });

    const minValue = _.min(variantValues).toFixed(2);
    const maxValue = _.max(variantValues).toFixed(2);
    let valueRange = minValue + ' - ' + maxValue;

    if (minValue === maxValue) {
        valueRange = minValue;
    }
    return valueRange;
}
